export enum FinancesControlId {
  HideCorrectionPayments = 'hideCorrectionPayments',
}
